function searchCards(
  { filters, limit, metadataIds, postTypes = [], recommendationTypes = [], query, searchType },
  apiClient
) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/cards/search`;
  return apiClient.post(route, {
    experiment: undefined,
    limit,
    metadataIds,
    postTypes,
    recommendationTypes,
    query,
    searchType,
    ...filters
  });
}

export default {
  searchCards
};
